'use strict';

/**
 * 获取加入公参和searchObj参数的url
 * example: getHref('index', { entry: 'test' }) === 'http://${当前的host+path}/index?uc_param_str=xx&entry=test'
 * @param  {[type]} where          [description]
 * @param  {Object} [searchObj={}] [description]
 * @return {[type]}                [description]
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isString = isString;
exports.getHref = function (where) {
  var searchObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var net = require('@ali/network');
  var urlHref = location.href.substring(0, location.href.lastIndexOf('/') + 1);
  urlHref = urlHref + where;
  // todo remove ds=xx&sn=xx, update network cmp
  urlHref = net.parseQuery(searchObj, net.ucParam(urlHref, true));
  return urlHref;
};

/**
 * 返回>= m && <= n 的随机数
 * @param  {[int]} m [description]
 * @param  {[int]} n [description]
 * @return {[int]}   [description]
 */
exports.getRandom = function (m, n) {
  return Math.floor(Math.random() * (n - m + 1) + m);
};

/**
 * 返回随机返回数组中一个元素
 * @param  {[Array]} arr [数组]
 * @return {[everyThing]}   [返回的元素]
 */
exports.getArrayRandom = function (arr) {
  return arr[exports.getRandom(0, arr.length - 1)];
};

/**
 * object to className string
 * @param {[Object]} obj 逻辑对象，key 为可能需要的 className
 * @return {string} 拼接好的 class 字符串
 * @example classlists({ aaa: true, bbb: false })  => 'aaa'
 */
exports.classlists = function (obj) {
  var clsArr = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && !!obj[key]) {
      clsArr.push(key);
    }
  }
  return clsArr.join(' ');
};

/**
 * 通过语言包 key 获取文案
 * @private
 * @param  {String} localeKey   语言包 key 值
 * @return {String}             不存在则返回 undefined
 */
exports.getTextByLocaleKey = function (localeKey) {
  if (typeof window === 'undefined') return;
  if (!window.__intl__ || !window.__intl__.messages) return;

  var intl = window.__intl__.messages;
  var value = getObj(intl, localeKey);

  if (!value) return localeKey;
  return value;
};

/**
 * 获取变量是否是字符串类型
 * @private
 * @param  {String} val          变量
 * @return {Boolean}             true or false
 */
exports.isString = function (val) {
  return _rt('s') === _rt(val);
};

/**
 * 获取变量是否是数组类型
 * @private
 * @param  {String} val          变量
 * @return {Boolean}             true or false
 */
exports.isArray = function (val) {
  return _rt([]) === _rt(val);
};

/**
 * 获取单个cookie的值
 * @Param {String}  cookieName  cookie的名称
 * @Return {String} cookie值
 **/
exports.getCookie = function (cookieName) {
  var cookieObj = {};
  var cookieSplit = [];
  var cookieArr = document.cookie.split(';');
  for (var i = 0, len = cookieArr.length; i < len; i++) {
    if (cookieArr[i]) {
      cookieSplit = cookieArr[i].split('=');
      cookieObj[cookieSplit[0].trim()] = cookieSplit[1].trim();
    }
  }
  return cookieObj[cookieName];
};

function _rt(val) {
  return Object.prototype.toString.call(val);
}

/**
 * getObj 通过 key string 获取对象的属性值
 * @usage getObj(obj, 'a.b.c')
 *
 * @param  {Object} obj         对象
 * @param  {String} [keyStr=''] key string
 * @return {String}             不存在则返回 undefined
 */
function getObj(obj) {
  var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var ARRAY_PATH_REGEXP = /\[\s*(\d+)\s*\]/;
  var keyArr = keyStr.split('.');
  for (var i = 0; i < keyArr.length; i++) {
    var key = keyArr[i];
    if (!obj) {
      return;
    }
    var matchArrayPath = key.match(ARRAY_PATH_REGEXP);
    if (matchArrayPath && matchArrayPath[1]) {
      obj = obj[key.replace(ARRAY_PATH_REGEXP, '')][matchArrayPath[1]];
    } else {
      obj = obj[key];
    }
  }
  return obj;
}

/**
 * pickObj 将对象精简到指定的属性
 *
 * @param {object} obj          对象
 * @param {string[]} [arr=[]]   指定属性名数组
 * @return {object}             精简后的对象
 */
function pickObj(obj) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var newObj = {};
  arr.forEach(function (key) {
    newObj[key] = obj[key];
  });
  return newObj;
}

/**
 * 移除 url 上某个指定的参数 (Immutable 的)
 *
 * @param {any} key 参数名
 * @param {any} sourceURL 原始 url
 * @return {string} 新的 url
 */
function removeParam(key, sourceURL) {
  var rtn = sourceURL.split('?')[0];
  var param = void 0;
  var params_arr = [];
  var queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    params_arr = queryString.split('&');
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = rtn + '?' + params_arr.join('&');
  }
  return rtn;
}

/**
 * @param {string} str string
 * @return {boolean} true: is string; false: not a string
 */
function isString(str) {
  return Object.prototype.toString.call(str) === '[object String]';
}

exports.getObj = getObj;
exports.pickObj = pickObj;
exports.removeParam = removeParam;